module.exports = __webpack_public_path__ + "img/close-white.840ed37b.svg";